import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';

export default class TaxException extends BaseDangerDetail {
    constructor(props) {
        super(props);
        this.title = '所得税费用情况';
    }

    getColumns = () => {
        return [{
            title: '当期所得税费用',
            dataIndex: 'comintax'
        }, {
            title: '占利润总额比例',
            dataIndex: 'proportion'
        }, {
            title: '目标公司所得税税率',
            dataIndex: 'comintaxrate',
            render: val => val + '%'
        }];
    };
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialFraudAnalysis/subComponents/details/TaxException.jsx